import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "ProfesionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "ProfesionPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexProfesion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Profesion', name: 'Profesion', title: 'Profesion' },
                { data: 'Fuerza', name: 'Fuerza', title: 'Fuerza' },
                { data: 'Nivel', name: 'Nivel', title: 'Nivel' },
                { data: 'TipoProfesion', name: 'TipoProfesion', title: 'Tipo de Profesion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            profesions: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            profesion: {},

        };
    },
    methods: {

        newProfesion() {
            this.profesion = {};
            this.$refs['frm-profesion'].show();
            // console.log("hhhhola")
        },
        showProfesion(id) {
            this.isLoading=true;
            this.ss.showProfesion(id).then(
                (result) => {
                    let response = result.data;
                    this.profesion = response.data;
                    this.$refs['view-profesion'].show();
                    this.isLoading = false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        editProfesion() {
            this.$refs['frm-profesion'].show();
            this.$refs['view-profesion'].hide();
        },
        cancelProfesion() {
            if (this.profesion.id) {
                this.$refs['view-profesion'].show();
            }
            this.$refs['frm-profesion'].hide();
        },
        saveProfesion() {
            this.ss.storeProfesion(this.profesion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-profesion'].hide();
                    this.$refs['datatable-profesion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteProfesion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyProfesion(this.profesion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-profesion'].hide();
                                this.$refs['datatable-profesion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
       
        draw() {
            window.$('.btn-datatable-Profesion').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showProfesion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {

        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
